import React from 'react';
import { Container, Typography } from '@mui/material';
import { PasswordReset } from '../components/PasswordReset';

export const PasswordResetPage: React.FC = () => (
  <Container maxWidth="sm">
    <Typography variant="h4" align="center" sx={{ mt: 8 }}>
      Password Reset
    </Typography>
    <PasswordReset />
  </Container>
);
